import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCeDjkOn7HXFeHyQsjl1Zg591tFzzlQsqE",
  authDomain: "lizasareeshapers.firebaseapp.com",
  projectId: "lizasareeshapers",
  storageBucket: "lizasareeshapers.firebasestorage.app",
  messagingSenderId: "851089893399",
  appId: "1:851089893399:web:d2b6e71b52b59779259452",
  measurementId: "G-H2PH6VJZ50"
};

const app = initializeApp(firebaseConfig);
export const storageBucket = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);

// Order/payment constants live in a Firebase-free module so the serverless
// API routes can import them without loading the browser SDK.
export {
  collections,
  roles,
  cart_status,
  payment_status,
  carting,
} from "./utils/orderConstants";
